export function initObserver(element) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (element.is_visible) {
        element.is_visible = !!entry.intersectionRatio
      }
      else {
        element.is_visible = entry.intersectionRatio >= 0.25
      }
    });
  }, {
    threshold: [
      0,
      0.25,
    ],
  })

  const DOMElement = document.getElementById(element.id);
  if (!DOMElement) return;

  observer.observe(DOMElement);
  return observer;
}
